// src/components/user/BusinessInfoForm.tsx

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Form, Input, App } from 'antd';

const BusinessInfoForm: React.FC = () => {
    const { t } = useTranslation();
    const { message } = App.useApp();

    // Filter out Arabic characters (Unicode range \u0600-\u06FF)
    const filterArabicCharacters = (value: string): string => {
        return value.replace(/[\u0600-\u06FF]/g, '');
    };

    const showArabicError = () => {
        message.warning(t('auth.validation.noArabicCharacters'));
    };

    return (
        <Card title={t('text.business_info')} style={{ marginBottom: 0 }}>
            <Form.Item
                label={t('text.tax_registry')}
                name={['business_info', 'taxeregistry']}
                rules={[{ required: true, message: t('message.value_required') }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label={t('text.name')}
                name={['business_info', 'name']}
                rules={[
                    { required: true, message: t('message.value_required') },
                    {
                        validator: (_, value) => {
                            if (value && /[\u0600-\u06FF]/.test(value)) {
                                return Promise.reject(new Error(t('auth.validation.noArabicCharacters')));
                            }
                            return Promise.resolve();
                        },
                    },
                ]}
                getValueFromEvent={(e) => {
                    const filtered = filterArabicCharacters(e.target.value);
                    if (filtered !== e.target.value) {
                        showArabicError();
                    }
                    return filtered;
                }}
                normalize={(value) => filterArabicCharacters(value || '')}
            >
                <Input />
            </Form.Item>
        </Card>
    );
};

export default BusinessInfoForm;
